import axios from 'axios';
import { Toast } from "antd-mobile";


const baseUrl = process.env.NODE_ENV === "development" ? '/index.php/' : 'http://todo.kairusi.cn/index.php/';
// const baseUrl = '/index.php/';

const successCode = [200, -4];


const statusCheck = (response) => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const error = new Error(response.statusText || '服务异常！');
    error.response = response;
    throw error;
}
const resultCheck = (response) => {
    if (successCode.includes(response.data.res)) return response.data;
    let content = "";
    if (response.data.res === -2) {
        content = "您还不是VIP，升级会员后可享受所有功能";
    } else if (response.data.res === -1) {
        content = "请重新登录！";
    } else {
        content = response.data.msg || '服务异常！';
    }
    // message.destroy();
    if (response.data.res === -2) {

    } else {
        // message.warning({
        //     duration: 2,
        //     content: content,
        //     className: 'custom-class',
        // });
    }
    throw new Error(content);
}

const post = (url, params) => {
    const options = {
        method: 'post',
        url: `${baseUrl}${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json',
            'charset': 'utf-8',
            // 'SESSIONID': userInfo.session_id,
            "PRODUCT": "think_pc"
        }
    };
    return axios(options).then(statusCheck).then(resultCheck)
};
const get = (url, params) => {
    // const userInfo = store.getUserInfo() || {};
    const options = {
        method: 'get',
        url: `${baseUrl}${url}`,
        params: params,
        headers: {
            'Content-Type': 'application/json',
            'charset': 'utf-8',
            // 'SESSIONID': userInfo.session_id,
            "PRODUCT": "think_pc"
            // 'SESSIONID': 'ag6pqqlpvmhip6a157gfm1cdto'
        }
    };
    return axios(options).then(statusCheck).then(resultCheck)
};

const multipleRequest = (requsetList, callback) => {
    return axios.all(requsetList).then(axios.spread(callback))
};

export {
    get,
    post,
    multipleRequest,
};